// Package imports:
import React from "react";
// Component imports:
import Alert from "../../ui-elements/Alert/Alert";

// TEMPORARY notice (KOD-28157): HMS updates Fasteignaskrá over the weekend.
// Shown from Friday 2026-06-05 17:00 until Sunday 2026-06-07 13:00.
// Safe to delete this component and all its usages after that.
const START = new Date("2026-06-05T17:00:00");
const END = new Date("2026-06-08T17:00:00");

const HmsMaintenanceAlert: React.FC<{ style?: React.CSSProperties }> = ({ style }) => {
  const now = new Date();
  if (now < START || now > END) return null;
  return (
    <div style={{ width: "100%", marginBottom: "20px", ...style }}>
      <Alert
        type="info"
        headText="Uppfærsla á Fasteignaskrá hjá HMS"
        text="Vegna uppfærslu á Fasteignaskrá hjá HMS er ekki hægt að sækja upplýsingar um veðbönd og búast má við hægagangi á öðrum fyrirspurnum tengdum fasteignaskrá."
      />
    </div>
  );
};

export default HmsMaintenanceAlert;
